import React, { useState, useEffect } from "react";
import { Accordion } from "react-bootstrap";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Form from "react-bootstrap/Form";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import swal from "sweetalert";
import { get_suppliers, get_categories_forAll_services } from "../../../../../services/for_allServices";
import {
  update_stock_processing,
} from "../../../../../services/purchase_service";
import Button from "@mui/material/Button";
import DoneIcon from "@mui/icons-material/Done";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Set_refuse_reason from "./set_refuse_reason/Set_refuse_reason";
import View_refuse_reason from "../../view_refuse_reason/view_refuse_reason";

function get_supplier_by_id(id, suppliers) {
  const supplier = suppliers.find((supplier) => supplier.id === id);
  return supplier ? supplier.parentCompany : "Inconnu";
}

function Products({
  categories,
  suppliers,
  products,
  stockStatus,
  selectedProducts,
  setSelectedProducts,
}) {
  function getCategorieById(id) {
    const category = categories.find((cat) => cat.id_category === id);
    return category ? category.name : "Inconnu";
  }

  const handleCheckboxChange = (product) => {
    if (product.conforme === true) return;
    //check if product exist
    setSelectedProducts((prev) => {
      let isSelected = false;
      for (let p of prev) {
        if (p.product_code === product.product_code) {
          isSelected = true;
          break;
        }
      }

      //if produt exist remove it
      if (isSelected) {
        return prev.filter((p) => p.product_code !== product.product_code);
      } else {
        //ajouter le produit
        return [...prev, product];
      }
    });
  };

  return (
    <>
      {products.map((product, id) => (
        <TableRow key={"product_col" + id}>
          {(stockStatus === "reçu" || stockStatus === "non conforme") && (
            <TableCell align="left">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={
                    
                      selectedProducts.some(
                        (p) => p.product_code === product.product_code
                      )
                    }
                    onChange={() => handleCheckboxChange(product)}
                  />
                }
              />
            </TableCell>
          )}
          <TableCell align="left">{product.product_name || "N/A"}</TableCell>
          <TableCell align="left">
            {getCategorieById(parseInt(product.product_category))}
          </TableCell>
          <TableCell align="left">{product.product_reference}</TableCell>
          <TableCell align="left">{product.product_code}</TableCell>
          <TableCell align="left">
            {get_supplier_by_id(product.product_supplier, suppliers)}
          </TableCell>
          <TableCell align="center">
            {product.product_quantity_selected || 0}
          </TableCell>
        </TableRow>
      ))}
    </>
  );
}

const Stock_products_details = ({
  categories,
  suppliers,
  existing_products,
  stockStatus,
  selectedProducts,
  setSelectedProducts,
  columns,
}) => {
  return (
    <TableContainer className=" stock_products_details_table_container">
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell key={column.id} align={column.align}>
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {existing_products.length > 0 ? (
            <Products
              categories={categories}
              suppliers={suppliers}
              products={existing_products}
              stockStatus={stockStatus}
              selectedProducts={selectedProducts}
              setSelectedProducts={setSelectedProducts}
            />
          ) : (
            <TableRow>
              <TableCell colSpan={columns.length} align="center">
                Aucun produit disponible
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const InnerStockDetails = ({
  tmp_stock_processing,
  stockStatus,
  request_details,
  request_code,
  setStockStatus,
}) => {
  const [existing_products, setexisting_products] = useState([]);
  const [suppliers, setsuppliers] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [open_reason_modal, setOpen_reason_modal] = useState(false);
  const [conforme_products, setConformeProducts] = useState([]);
  const [non_conforme_products, setNonConformeProducts] = useState([]);
  const [open_refuse_reason_modal, setOpen_refuse_reason_modal] = useState(null);
  const [refuse_reason, setRefuse_reason] = useState('');

  const [waiting, setWaiting] = useState(false);

  const allChecked = existing_products.length > 0 && existing_products.every(
    (product) => product.conforme === true ||
      selectedProducts.some((sp) => sp.product_code === product.product_code));

  const columns = [
    ...(stockStatus === "reçu" || stockStatus === "non conforme"
      ? [{ id: "select", label: "", align: "center" }]
      : []),
    { id: "product_name", label: "Produit", align: "left" },
    { id: "product_category", label: "Catégorie de Produit", align: "left" },
    { id: "product_reference", label: "Référence du produit", align: "left" },
    { id: "product_code", label: "Code de produit", align: "left" },
    { id: "supplier", label: "Fournisseur", align: "left" },
    { id: "product_quantity_selected", label: "Quantité", align: "left" },
  ];

  useEffect(() => {
    async function load_data() {
      try {
        const suppliersResponse = await get_suppliers();
        setsuppliers(suppliersResponse.data);

        const categoriesResponse = await get_categories_forAll_services();
        setCategories(categoriesResponse.data);

        if (tmp_stock_processing?.products_taken) {
          // Add product_quantity_selected to each product if it doesn't exist
          const productsWithQuantity = tmp_stock_processing.products_taken.map(
            (product) => ({
              ...product,
              product_quantity_selected: product.product_quantity_selected || 0,
            })
          );
          setSelectedProducts(productsWithQuantity); 

          setexisting_products(productsWithQuantity);
          setRefuse_reason(tmp_stock_processing.non_conformity_reason);
        }
      } catch (error) {
        console.error("Error loading data:", error);
      }
    }

   //  console.log("InnerStockDetails props:", tmp_stock_processing);

    if (request_details) {
      load_data();
    }

    if (non_conforme_products.length > 0) {
      setOpen_reason_modal(true);
    }
  }, [request_details, non_conforme_products]);

  function state(request_state) {
    return (
      <>
        {request_state === "En cours de livraison" ? (
          <Button variant="contained" className="status_waiting">
            {request_state}
          </Button>
        ) : request_state === "non conforme" ? (
          <Button variant="contained" className="status_deny">
            {request_state}
          </Button>
        ) : request_state === "reçu" || request_state === "conforme" ? (
          <Button variant="contained" className="status_success">
            {request_state}
          </Button>
        ) : (
          <Button variant="contained" className="status_default">
            Statut inconnu
          </Button>
        )}
      </>
    );
  }

  const handleReceiveDelivery = async () => {
    swal({
      title: "Confirmer la réception ",
      text: "Êtes-vous sûr de vouloir confirmer la réception de la commande ? ",
      icon: "warning",
      buttons: true,
    }).then(async (isConfirm) => {
      if (isConfirm) {
        try {
          setWaiting(true);
         //  console.log("User confirmed the reception of the order");
          const now = new Date();
          const received_date = now
            .toLocaleString("sv-SE", { timeZone: "UTC" })
            .replace("T", " ");

          const requestData = {
            request_code: request_code,
            received_date: received_date,
            status: "reçu",
          };

          const response = await update_stock_processing(requestData);
          setStockStatus("reçu");
         //  console.log("response", response);

          swal("Confirmation enregistrée!", " ", "success");
        } catch (error) {
          console.error("Error updating received date:", error.response);
        }
        setWaiting(false);
      }
    });
  };

  const handleConformeAction = async () => {
    const newlySelectedProducts = existing_products.filter(
      (p) =>
        selectedProducts.some((sp) => sp.product_code === p.product_code) ||
        p.conforme === true
    );

    setConformeProducts(newlySelectedProducts);

    const nonConformeProducts = existing_products.filter(
      (p) =>
        !newlySelectedProducts.some((sp) => sp.product_code === p.product_code)
    );

    setNonConformeProducts(nonConformeProducts);

   //  console.log({ newlySelectedProducts, nonConformeProducts });

    if (nonConformeProducts.length === 0) {
      swal({
        title: "La commande est conforme",
        text: "Voulez-vous confirmer la conformité de la commande ?",
        icon: "warning",
        buttons: true,
      }).then(async (isConfirm) => {
        if (isConfirm) {
          try {
            setWaiting(true);
           //  console.log("User confirmed the conformity of the order");

            const now = new Date();
            const conformity_date = now
              .toLocaleString("sv-SE", { timeZone: "UTC" })
              .replace("T", " ");

            const updated_products_taken =
              tmp_stock_processing.products_taken.map((product) => ({
                ...product,
                conforme: true,
              }));

            const requestData = {
              request_code: request_code,
              conformity_date,
              status: "conforme",
              products_taken: updated_products_taken,
            };

            const response = await update_stock_processing(requestData);
            setStockStatus("conforme");
           //  console.log("response", response);

            swal("Confirmation enregistrée!", " ", "success");
          } catch (error) {
            console.error("Error updating conformity status:", error.response);
          }
          setWaiting(false);
        }
      });
    } else {
      // Open modal only if there are non-conform products
      setOpen_reason_modal(true);
    }
  };

  return (
    <Accordion>
      <Accordion.Item eventKey="0">
        <Accordion.Header>
          <div className="order_accordion_header">
            <div className="accordion_header_content">
              <span>Commande interne </span>
              {existing_products.length > 0 && (
                <div className="existing_products_indicator_container">
                  <div className="existing_products_indicator">
                    {existing_products.length}
                  </div>
                </div>
              )}{" "}
            </div>

            <div className="request_state_container">
              {stockStatus && (
                <div className="request_state_container">
                  {state(stockStatus)}
                </div>
              )}
              {
                stockStatus === "non conforme"
                  ? <span className='view_reason_button' onClick={(e) => { e.stopPropagation(); setOpen_refuse_reason_modal(refuse_reason) }}>Motif</span>
                  : <></>
              }
            </div>
          </div>
        </Accordion.Header>
        <Accordion.Body>
          <div className="order_plus_details_container">
            {suppliers.length > 0 && categories.length > 0 ? (
              <Stock_products_details
                categories={categories}
                suppliers={suppliers}
                existing_products={existing_products}
                stockStatus={stockStatus}
                selectedProducts={selectedProducts}
                setSelectedProducts={setSelectedProducts}
                columns={columns}
              />
            ) : (
              <p>Chargement des données...</p>
            )}
          </div>
          <div className="order_plus_details_container">
            <div className="proceed_button_container">
              {stockStatus === "reçu" || stockStatus === "non conforme" ? (
                <div className="button-group">
                  <Button
                    variant="contained"
                    className={`submit_but ${allChecked ? "valide_but" : "cancel_but"}`}
                    onClick={() => handleConformeAction()}
                  >
                    {allChecked ? "Commande conforme" : "Commande non conforme"}
                  </Button>
                </div>
              ) : stockStatus === "En cours de livraison" ? (
                <Button
                  variant="contained"
                  className="submit_but valide_but"
                  startIcon={<DoneIcon className="my_icon" />}
                  onClick={handleReceiveDelivery}
                >
                  recevoir la commande
                </Button>
              ) : null}
            </div>
          </div>
          {open_reason_modal ? (
            <Set_refuse_reason
              open_reason_modal={open_reason_modal}
              setOpen_reason_modal={setOpen_reason_modal}
              conforme_products={conforme_products}
              non_conforme_products={non_conforme_products}
              request_code={request_code}
              setStockStatus={setStockStatus}
            />
          ) : null}
          {open_refuse_reason_modal !== null
            ? <View_refuse_reason open_reason_modal={open_refuse_reason_modal} setOpen_reason_modal={setOpen_refuse_reason_modal} />
            : <></>}
        </Accordion.Body>
      </Accordion.Item>
      <Backdrop
                      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                      open={waiting}
                  >
                      <CircularProgress color="inherit" />
                  </Backdrop>
    </Accordion>
  );
};

export default InnerStockDetails;
